import React, { useState, useEffect } from "react";
import axios from "axios";
import AddBank from "./AddBank";
import CompensationBeneficiaryUpdate from "./CompensationBeneficiaryUpdate";
import LandAcquistion from "./LandAcquistion";
import SubmitProposal from "./SubmitProposal";
import { FloatingLabel } from "flowbite-react";

const ManualBeneficiary = ({ initialVillages, compensationsId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [isModalOpenLand, setIsModalOpenLand] = useState(false);
  const [compensationtype, setCompensationType] = useState();
  const [currentStep, setCurrentStep] = useState(0);
  const [mastercompensationtype, setMasterCompensationType] = useState([]);
  const [beneficiaryNameDetails, setBeneficiaryNameDetails] = useState([]);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [mastermanualinsert, setMasterManualInsert] = useState([]);
  const [manualinsert, setManualInsert] = useState();
  const [insertmanualdetailsData, setInsertManualDetailsData] = useState();
  const [compensationID, setCompensationsID] = useState();
  const [totalCompensation, setTotalCompensation] = useState(null);

  // const [beneficiaryDetails, setBeneficiaryDetails] = useState([]);
  const [beneficiaryDetails, setBeneficiaryDetails] = useState([]);

  const handleUpdate = (updatedDetails) => {
    setBeneficiaryDetails(updatedDetails);
  };
  const [governmentIdFile, setGovernmentIdFile] = useState([]);
  const [compensationKhasraDetails, setCompensationKhasraDetails] = useState(
    []
  );
  const [totalcompensationamount, setTotalCompensationAmount] = useState([]);
  const [compensationsubtype, setCompensationSubType] = useState();
  const [mastercompensationsubtype, setMasterCompensationSubType] = useState(
    []
  );
  const [tableData, setTableData] = useState([]);
  // Step titles
  const steps = ["Road Details", "Beneficiary Details", "Submit Proposal"];
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [iniatialBlock, setIniatialBlock] = useState([]);
  const [error, setError] = useState(null);
  const [insertmanualbeneficiaryData, setInsertManualBeneficiaryData] =
    useState();
  const [formData, setFormData] = useState({
    khasra: "",
    totalRakwa: "",
    acquiredLength: "",
    acquiredWidth: "",
    acquireArea: "",
    circleRate: "",
    KhataNo: "",
  });
  const [formData1, setFormData1] = useState({
    Name: "",
    ContactNo: "",
    GovernmentIdFile: "",
    Address: "",
    VillageCode: "",
    KhataNo: "",
    LandConsentType: null,
    PowerOfAttorneyTo: null,
    PowerOfAttorneyFile: null,
    Affidavit: null,
    PaymentStatus: null,
    ShareConsentType: null,
    ShareConsentTypeFile: null,
    LandShare: 0,
    CompensationAmount: 0,
  });
  console.log("mastermanualinsert", mastermanualinsert);
  const villageCodebank = formData.VillageCode;
  const KhataNobank = formData.KhataNo;

  const handleVillageChange = (e) => {
    const selectedValue = JSON.parse(e.target.value); // Parse the selected option
    setFormData({
      ...formData,
      VillageCode: selectedValue.VillageCode, // Update village code
      VillageNameHindi: selectedValue.VillageNameHindi, // Update village name
    });
    setFormData1({
      ...formData1,
      VillageCode: selectedValue.VillageCode, // Update village code
      VillageNameHindi: selectedValue.VillageNameHindi, // Update village name
    });
  };

  // Handle step click
  const handleStepClick = (index) => {
    setCurrentStep(index); // Move to the clicked step
  };

  const fetchInitialBlock = async () => {
    try {
      const response = await axios.get(
        `https://backurrda.sarmar.co.in/api/MasterApi/CompensationBlockGet/${compensationsId}`
      );
      if (response.data) {
        setIniatialBlock(response.data);
        console.log("object", response.data);
      } else {
        console.error("No disrict data found");
      }
    } catch (error) {
      console.error("Error fetching District:", error);
    }
  };
  useEffect(() => {
    fetchInitialBlock();
  }, []);

  console.log("iniatialBlock", iniatialBlock);
  const BlockName = iniatialBlock[0]?.BlockName;

  const formattedVillages = initialVillages.map((village) => ({
    VillageCode: village.VillageCode,
    VillageNameHindi: village.VillageNameHindi,
  }));
  // const VillageCode = formattedVillages[0].VillageCode

  console.log("KhataNo", formData1.KhataNo);
  console.log("VillageCode", formData.VillageCode);

  const fetchCompensationKhasraDetails = async () => {
    debugger;
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/Beneficiary/GetCompensationKhasraDetails?compensationId=${compensationsId}&mode=${"2"}&villageCode=${
          formData.VillageCode
        }&khataNo=${formData.KhataNo}`
      );
      // const { TotalCompensation } = response.data;
      // setTotalCompensation(TotalCompensation);
      if (response.ok) {
        debugger;
        const data = await response.json();
        setCompensationKhasraDetails(data);
        console.log('compensationKhasraDetails',compensationKhasraDetails);
        setTotalCompensationAmount(data.TotalCompensation);
        console.log("data", data);
      } else {
        console.error(
          "Failed to fetch villages. HTTP Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
    }
  };
  useEffect(() => {
    fetchCompensationKhasraDetails();
  }, []);

  const fetchBeneficiaryDetails = async () => {
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/Beneficiary/GetDetails?compensationId=${compensationsId}&villageCode=${formData.VillageCode}&khataNo=${formData.KhataNo}`
      );
      if (response.ok) {
        const data = await response.json();
        setBeneficiaryDetails(data);
        console.log("BeneficiaryDetails", data);
      } else {
        console.error(
          "Failed to fetch BeneficiaryDetails. HTTP Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching BeneficiaryDetails:", error);
    }
  };
  useEffect(() => {
    fetchBeneficiaryDetails();
  }, []);

  const fetchBeneficiaryNameDetails = async () => {
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/Beneficiary/GetBeneficiaryCompensationDetails1?compensationId=${compensationsId}&villageCode=${formData.VillageCode}&khataNo=${formData.KhataNo}`
      );
      if (response.ok) {
        const data = await response.json();
        debugger;
        setBeneficiaryNameDetails(data);
        sessionStorage.clear();
        debugger;
        sessionStorage.setItem("beneficiaryNameDetails", JSON.stringify(data));

        console.log("BeneficiaryNameDetails", data);
      } else {
        console.error(
          "Failed to fetch BeneficiaryDetails. HTTP Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching BeneficiaryDetails:", error);
    }
  };
  useEffect(() => {
    fetchBeneficiaryNameDetails();
  }, []);

  const handleBeneficiaryDetailsInputChange = (e) => {
    const { name, value } = e.target;
    setFormData1((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      console.log("Updated formData1:", updatedData);
      return updatedData;
    });
  };
  const handleAddBeneficiary = async () => {
    try {
      // Create a FormData object
      const formDataObj = new FormData();
      formDataObj.append("CompensationId", compensationsId); // Add CompensationId
      formDataObj.append("VillageCode", formData.VillageCode || ""); // Use VillageCode from formData1
      formDataObj.append("KhataNo", formData.KhataNo || ""); // Use KhataNo from formData1
      formDataObj.append("Name", formData1.Name || ""); // Add Name
      formDataObj.append("Address", formData1.Address || ""); // Add Address
      formDataObj.append("ContactNo", formData1.ContactNo || ""); // Add ContactNo
      formDataObj.append("LandConsentType", null);
      formDataObj.append("PowerOfAttorneyTo", null);
      formDataObj.append("PowerOfAttorneyFile", null);
      formDataObj.append("Affidavit", null);
      formDataObj.append("PaymentStatus", null);
      formDataObj.append("ShareConsentType", null);
      formDataObj.append("ShareConsentTypeFile", null);
      formDataObj.append("LandShare", 0);
      formDataObj.append("CompensationAmount", 0);

      // Add the government ID file if provided
      if (governmentIdFile) {
        formDataObj.append("GovernmentIdFile", governmentIdFile);
      }

      // Send the request
      const response = await axios.post(
        "https://backurrda.sarmar.co.in/api/Beneficiary/InsertBeneficiaryCompensationDetails",
        formDataObj,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Ensure correct content type
          },
        }
      );

      console.log(response);

      if (response.status === 200 && response.data) {
        fetchBeneficiaryDetails(); // Refresh the beneficiary details
        return { compensationID: response.data }; // Return compensation ID
      } else {
        console.error("Compensation ID not found in response.");
        throw new Error("Compensation ID not found");
      }
    } catch (err) {
      console.error("Error in Insert Compensation Data API:", err);
      throw err;
    }
  };

  // const handleAddBeneficiary = async () => {
  //   try {
  //     const formData = new FormData(); // Create FormData object
  //     formData.append("CompensationId", compensationsId); // Adjust if needed
  //     formData.append("EntryDate", new Date().toISOString());

  //     // Add all other text fields
  //     Object.keys(formData1).forEach((key) => {
  //       formData.append(key, formData1[key]);
  //     });

  //     // Append file
  //     if (governmentIdFile) {
  //       formData.append("GovernmentIdFile", governmentIdFile);
  //     }

  //     const response = await axios.post(
  //       "https://backurrda.sarmar.co.in/api/Beneficiary/InsertBeneficiaryCompensationDetails",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data", // Ensure correct content type
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       alert("Beneficiary details added successfully!");
  //   fetchBeneficiaryDetails();

  //     } else {
  //       console.error("Failed to add beneficiary details:", response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error adding beneficiary details:", error);
  //   }
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setGovernmentIdFile(file); // Ensure this state is defined
    setFormData1({
      ...formData1,
      GovernmentIdFile: file,
    });
    console.log("File selected:", file);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    debugger;
    const { name, value } = e.target; // Ensure this captures name and value
    // setFormData({ ...formData, [name]: value });
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };
      console.log("Updated formData :", updatedData);
      return updatedData;
    });
    setFormData1((prev) => ({
      ...prev,
      KhataNo: value,
      VillageCode: value,
    }));
  };

  // Add data to the table
  const handleAddToTable = () => {
    if (
      formData.khasra &&
      formData.totalRakwa &&
      formData.acquiredLength &&
      formData.acquiredWidth &&
      formData.circleRate
    ) {
      setTableData([...tableData, formData]);
      // Reset form data
      setFormData({
        khasra: "",
        totalRakwa: "",
        acquiredLength: "",
        acquiredWidth: "",
        circleRate: "",
      });
    } else {
      alert("Please fill all fields before adding!");
    }
  };

  // Toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    fetchBeneficiaryNameDetails();
  };
  const toggleModals = () => {
    setIsModalOpenUpdate(!isModalOpenUpdate);
  };
  const toggleModales = () => {
    setIsModalOpenLand(!isModalOpenLand);
  };

  const fetchCompensationType = async () => {
    try {
      const response = await axios.get(
        "https://backurrda.sarmar.co.in/api/MasterApi/CompensationTypeGet"
      );
      if (response.data) {
        setMasterCompensationType(response.data);
      } else {
        console.error("No Compensation Type data found");
      }
    } catch (error) {
      console.error("Error fetching Compensation Type:", error);
    }
  };

  const fetchCompensationSubType = async (CompensationTypeId) => {
    try {
      setMasterCompensationSubType("");
      const response = await axios.get(
        `https://backurrda.sarmar.co.in/api/MasterApi/CompensationSubTypeGet/${CompensationTypeId}`
      );
      if (response.data) {
        setMasterCompensationSubType(response.data);
      } else {
        console.error("No Compensation Sub Type data found");
      }
    } catch (error) {
      console.error("Error fetching Compensation Sub Type:", error);
    }
  };

  const fetchManualDetails = async (compensationsId) => {
    debugger;
    try {
      // setManualInsert("");
      const response = await axios.get(
        `https://backurrda.sarmar.co.in/api/Beneficiary/GetForm2MainEntries?compensationId=${compensationsId}`
      );
      if (response.data) {
        setMasterManualInsert(response.data);
      } else {
        console.error("No Compensation Sub Type data found");
      }
    } catch (error) {
      console.error("Error fetching Compensation Sub Type:", error);
    }
  };

  const insertManualDetails = async () => {
    debugger;
    // Create the payload
    const payload = {
      ...insertmanualdetailsData,
      VillageName: formData.VillageNameHindi,
      VillageCode: formData.VillageCode, // Update this with the actual value if needed
      CompensationId: compensationsId, // Update this with the actual value if needed
      KhasraNo: formData.khasra,
      KhataNo: formData.KhataNo,
      Block: BlockName,
      CompensationType: compensationtype,
      CompensationSubType: compensationsubtype,
    };

    try {
      const response = await axios.post(
        "https://backurrda.sarmar.co.in/api/Beneficiary/InsertForm2MainEntry",
        payload
      );

      console.log(response);

      if (response.status === 200 && response.data) {
        debugger;
        setMasterManualInsert([]);
        fetchManualDetails(response.data[0].CompensationId);

        setCompensationsID(response.data[0].CompensationId);

        return response.data[0].CompensationId;
      } else {
        console.error("compensationsId ID not  in response.");
        throw new Error("Compensation ID not found");
      }
    } catch (err) {
      console.error("Error in Insert Compensation Data API:", err);
      throw err;
    }
  };

  const insertManualBeneficiary = async () => {
    debugger;
    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true);
    // Calculate AcquireArea
    const acquireArea = formData.acquireArea;
    const CompensationAmount = acquireArea * formData.circleRate;
    // Create the payload
    const payload = {
      ...insertmanualbeneficiaryData,
      VillageCode: formData.VillageCode || null, // Update this with the actual value if needed
      CompensationId: compensationsId || null, // Update this with the actual value if needed
      KhasraNo: formData.khasra || null,
      KhataNo: formData.KhataNo || null,
      totalRakwa: formData.totalRakwa || null,
      acquiredLength: formData.acquiredLength || 0,
      acquiredWidth: formData.acquiredWidth || 0,
      circleRate: formData.circleRate || null,
      acquireArea: acquireArea || null, // Add the calculated area
      CompensationAmount: CompensationAmount || null,
    };

    try {
      const response = await axios.post(
        "https://backurrda.sarmar.co.in/api/Beneficiary/InsertCompensationKhasraDetails",
        payload
      );

      console.log(response);

      if (response.status === 200 && response.data) {
        debugger;
        await fetchCompensationKhasraDetails();

        // return ( response.data );
      } else {
        console.error("compensationsId ID not  in response.");
        throw new Error("Compensation ID not found");
      }
    } catch (err) {
      console.error("Error in Insert Compensation Data API:", err);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmits = async (e) => {
    debugger;

    e.preventDefault();

    if (
      !formData.khasra ||
      !formData.totalRakwa ||
      // !formData.acquiredLength ||
      // !formData.acquiredWidth ||
      !formData.acquireArea ||
      !formData.circleRate
    ) {
      alert("Please fill all required fields before submitting.");
      return;
    }
    if (isSubmitting) return;

    try {
      const cyx = await insertManualBeneficiary();
    } catch (err) {
      console.error("Error in handleSubmit:", err);
    }
  };

  const handleManualInsert = async (e) => {
    debugger;
    e.preventDefault();

    try {
      // await insertManualDetails();
      const { CompensationId } = await insertManualDetails();
      console.log(CompensationId);
      setCompensationsID(CompensationId);
      alert("Save Manual Data");
      // setCurrentStep(1);
      // Navigate("");
    } catch (err) {
      console.error("Error in handleSubmit:", err);
    }
  };

  useEffect(() => {
    fetchCompensationType();
    fetchCompensationSubType();
    fetchManualDetails(compensationsId);
  }, []);

  const getFileUrl = (filePath) => {
    if (!filePath) return null; // Return null if the file path is empty
    const fileName = filePath.split("\\").pop(); // Extract file name
    return `https://backurrda.sarmar.co.in/api/Files/view/${fileName}`;
  };

  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();
    setError(null);

    // const formData = new FormData();
    // Object.entries(files).forEach(([key, file]) => {
    //   formData.append(key, file);
    // });

    // if (isSubmitting) return;

    try {
      const CompensationId = await insertManualDetails();
      console.log(CompensationId);
      setCompensationsID(CompensationId);

      alert("Save Manual Benficiary Data");
      setCurrentStep(2);
      // Navigate("");
    } catch (err) {
      console.log("Error in Add Manual Benficiary Data:", err);
      setError(err.message);
      alert("Failed to Add Manual Benficiary Data");
    }
  };

  return (
    <div className="p-6">
      {/* <div className="flex justify-between items-center mb-6">
  {steps.map((step, index) => (
    <div
      key={index}
      className={`flex items-center ${
        index <= currentStep ? "cursor-pointer" : "cursor-not-allowed"
      }`}
      onClick={() => {
        if (index <= currentStep) {
          handleStepClick(index); // Allow navigation only if the step is green
        }
      }}
    >
      <div
        className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold ${
          index <= currentStep ? "bg-green-500" : "bg-gray-300"
        }`}
      >
        {index + 1}
      </div>
      <span
        className={`ml-2 font-medium ${
          index === currentStep ? "text-green-500" : "text-gray-500"
        }`}
      >
        {step}
      </span>
      {index < steps.length - 1 && (
        <div className="w-72 border-t border-gray-300 border-dashed mx-2"></div>
      )}
    </div>
  ))}
</div> */}
      {currentStep === 0 && (
        <>
          <div className="flex-1 px-6 py-4 overflow-y-auto scroll-hidden">
            <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
              <h1>Manual Beneficiary Entry</h1>
            </div>
            <section className="mt-6">
              <h2 className="text-[#241C68] underline mb-4">
                {" "}
                &#x25CF; Land Details:
              </h2>
              <div className="grid grid-cols-8 gap-4 mb-6">
                {/* <div className="col-span-2">
                  <select
                    id="VillageCode"
                    name="VillageCode"
                    value={JSON.stringify({
                      VillageCode: formData.VillageCode,
                      VillageNameHindi: formData.VillageNameHindi,
                    })} // Matches the selected village
                    onChange={(e) => handleVillageChange(e)} // Use a single handler
                    className="border rounded-md p-2 w-full"
                  >
                    <option value="">Choose village</option>
                    {formattedVillages.map((item) => (
                      <option
                        key={item.VillageCode}
                        value={JSON.stringify({
                          VillageCode: item.VillageCode,
                          VillageNameHindi: item.VillageNameHindi,
                        })}
                      >
                        {item.VillageNameHindi}{" "}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div className="relative col-span-2">
                  <div className="form-floating">
                    <select
                      className="form-select block w-full px-2.5 pb-2.5 pt-5 text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      // id="floatingSelect"
                      id="VillageCode"
                      name="VillageCode"
                      value={JSON.stringify({
                        VillageCode: formData.VillageCode,
                        VillageNameHindi: formData.VillageNameHindi,
                      })} // Matches the selected village
                      onChange={(e) => handleVillageChange(e)}
                    >
                      <option value="">Choose village</option>
                      {formattedVillages.map((item) => (
                        <option
                          key={item.VillageCode}
                          value={JSON.stringify({
                            VillageCode: item.VillageCode,
                            VillageNameHindi: item.VillageNameHindi,
                          })}
                        >
                          {item.VillageNameHindi}{" "}
                        </option>
                      ))}
                    </select>
                    <label
                      htmlFor="floatingSelect"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                    >
                      Village
                    </label>
                  </div>
                </div>

                <div className="col-span-2">
                  <FloatingLabel
                    variant="standard"
                    label="Block"
                    className="mt-2 w-full"
                    name="Block"
                    value={BlockName}
                    disabled
                  />

                  {/* <input
                    className="border rounded-md p-2 w-full"
                    name="Block"
                    value={BlockName}
                    disabled
                  /> */}
                </div>
                <div className="relative col-span-2">
                  <div className="form-floating">
                    <select
                      className="form-select block w-full px-2.5 pb-2.5 pt-5 text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                      id="floatingSelect"
                      name="Compensation Type"
                      value={compensationtype}
                      onChange={(e) => {
                        const selectedCompensation = e.target.value;
                        setCompensationType(selectedCompensation);
                        if (selectedCompensation) {
                          setMasterCompensationSubType([]);
                          fetchCompensationSubType(selectedCompensation);
                        } else {
                          setMasterCompensationSubType([]);
                        }
                      }}
                    >
                      <option>Compensation Type</option>
                      {mastercompensationtype.map((compensationtype) => (
                        <option
                          key={compensationtype.Id}
                          value={compensationtype.Id}
                        >
                          {compensationtype.CompensationTypeName}
                        </option>
                      ))}
                    </select>
                    <label
                      htmlFor="floatingSelect"
                      className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                    >
                      Compensation Type
                    </label>
                  </div>
                </div>
                <div className="relative col-span-2">
                  {mastercompensationsubtype.length > 0 && (
                    <div className="form-floating">
                      <select
                        className="form-select block w-full px-2.5 pb-2.5 pt-5 text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        id="floatingSelect"
                        name="Compensation Sub-Type"
                        // className="border rounded-md p-2 w-full"
                        value={compensationsubtype}
                        onChange={(e) => {
                          setCompensationSubType(e.target.value); // Set sub-type selection
                        }}
                      >
                        <option value="">Compensation Sub-Type</option>
                        {mastercompensationsubtype.map(
                          (compensationsubtype) => (
                            <option
                              key={compensationsubtype.Id} // Assuming 'Id' is the unique identifier
                              value={compensationsubtype.Id} // Use the correct identifier for value
                            >
                              {compensationsubtype.CompensationSubTypeName}
                            </option>
                          )
                        )}
                      </select>

                      <label
                        htmlFor="floatingSelect"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                      >
                        Compensation Sub-Type
                      </label>
                    </div>
                  )}
                </div>

                <div className="col-span-2">
                  <FloatingLabel
                    variant="standard"
                    label="KhataNo"
                    // className="mt-2 w-full"
                    name="KhataNo"
                    value={formData.KhataNo}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-span-4 relative w-full sm:w-3/4 md:w-1/2 flex rounded-md">
                  <FloatingLabel
                    variant="standard"
                    label="Khasra No"
                    // className="col-span-2"
                    name="khasra"
                    value={formData.khasra}
                    onChange={handleInputChange}
                  />
                  <FloatingLabel
                    variant="standard"
                    label="Total Rakwa"
                    // className="col-span-1"
                    name="totalRakwa"
                    value={formData.totalRakwa}
                    onChange={handleInputChange}
                  />
                  {/* <input
                    className="border p-2 w-full"
                    placeholder="Acquired Length"
                    name="acquiredLength"
                    value={formData.acquiredLength}
                    onChange={handleInputChange}
                  /> */}

                  {/* <input
                    className="border p-2 w-full"
                    placeholder="Acquired Width"
                    name="acquiredWidth"
                    value={formData.acquiredWidth}
                    onChange={handleInputChange}
                  /> */}

                  <FloatingLabel
                    variant="standard"
                    label="Acquired Rakwa"
                    // className="col-span-1"
                    name="acquireArea"
                    value={formData.acquireArea}
                    onChange={handleInputChange}
                  />
                  <FloatingLabel
                    variant="standard"
                    label="Circle Rate"
                    // className="col-span-1"
                    name="circleRate"
                    value={formData.circleRate}
                    onChange={handleInputChange}
                  />
                  <button
                    className="absolute top-1/2 -right-1 transform -translate-y-1/2 bg-[#241C68] text-white px-2 py-1 rounded"
                    onClick={handleSubmits}
                    // onChange={handleSubmit}
                  >
                    +
                  </button>
                </div>

                {/* <div className="col-span-7 border text-left rounded-b-xl">
        <table className="w-full text-left">
          <thead className="bg-[#B4B4B4] text-center">
            <tr>
              <th className="border px-2 py-1">Khasra</th>
              <th className="border px-2 py-1">Total Rakwa</th>
              <th className="border px-2 py-1">Acquired Rakwa</th>
              <th className="border px-2 py-1">Circle Rate</th>
            </tr>
          </thead>
          <tbody>
            {[
              { name: "7 ", Rakwa: "0.3400", AcquiredRakwa: "360", CircleRate: "1000" },
              { name: "7 ख ", Rakwa: "0.350", AcquiredRakwa: "900", CircleRate: "2000" },
            ].map((village, index) => (
              <tr key={index}>
                <td className="border px-2 py-1 text-center">{village.name}</td>
                <td className="border px-2 py-1 text-center">{village.Rakwa}</td>
                <td className="border px-2 py-1 text-center">
                  <a href="#" className="text-[#241C68]">
                    {village.AcquiredRakwa}
                  </a>
                </td>
                <td className="border px-2 py-1 text-center">
                  <a href="#" className="text-[#241C68]">
                    {village.CircleRate}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div> */}
                <div className="col-span-7 border text-left rounded-b-xl mt-4">
                  <table className="w-full text-left">
                    <thead className="bg-[#D9D9D9] text-center">
                      <tr>
                        <th className="border px-2 py-1">Khata No.</th>

                        <th className="border px-2 py-1">Khasra</th>
                        <th className="border px-2 py-1">Total Rakwa</th>
                        {/* <th className="border px-2 py-1">Acquired Length</th>
                        <th className="border px-2 py-1">Acquired Width</th> */}
                        <th className="border px-2 py-1">Acquired Rakwa</th>
                        <th className="border px-2 py-1">Circle Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {compensationKhasraDetails?.map((data, index) => (
                        <tr key={index}>
                          <td className="border px-2 py-1 text-center">
                            {data.KhataNo}
                          </td>
                          <td className="border px-2 py-1 text-center">
                            {data.KhasraNo}
                          </td>
                          <td className="border px-2 py-1 text-center">
                            {data.TotalRakwa}
                          </td>
                          {/* <td className="border px-2 py-1 text-center">
                            {data.AcquiredLength}
                          </td>
                          <td className="border px-2 py-1 text-center">
                            {data.AcquiredWidth}
                          </td> */}
                          <td className="border px-2 py-1 text-center">
                            {data.AcquireArea}
                          </td>
                          <td className="border px-2 py-1 text-center">
                            {data.CircleRate}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
            <section className="mt-10">
              <h2 className="text-[#241C68] underline mb-4">
                &#x25CF; Beneficiary Details:
              </h2>
              <div className="grid grid-cols-8 gap-4 mb-6">
                <div className="col-span-3">
                  {/* <input
                    className="border rounded-md p-2 w-full"
                    placeholder="Name"
                    name="Name"
                    value={formData1.Name}
                    onChange={handleBeneficiaryDetailsInputChange}
                  /> */}
                  <FloatingLabel
                    variant="standard"
                    label="Name"
                    // className=""
                    name="Name"
                    value={formData1.Name}
                    onChange={handleBeneficiaryDetailsInputChange}
                  />
                </div>

                <div className="col-span-2">
                  {/* <input
                    className="border rounded-md p-2 w-full"
                    placeholder="Contact No"
                    name="ContactNo"
                    value={formData1.ContactNo}
                    onChange={handleBeneficiaryDetailsInputChange}
                  /> */}
                  <FloatingLabel
                    variant="standard"
                    label="Contact No"
                    // className=""
                    name="ContactNo"
                    value={formData1.ContactNo}
                    onChange={handleBeneficiaryDetailsInputChange}
                  />
                </div>

                {/* <div className="col-span-2">
                  <input
                    className="border rounded-md p-2 w-full"
                    id="document"
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}

                    onChange={(e) =>
                      setFormData1((prevData) => ({
                        ...prevData,
                        GovernmentId: e.target.files[0]?.name || "",
                      }))
                    }
                  />
                </div> */}
                <div className="flex col-span-2 items-center justify-center w-full">
                  <label
                    htmlFor="document"
                    className={`flex flex-col items-center justify-center w-full h-10 border-2 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-200 dark:hover:bg-gray-400`}
                  >
                    <div className="flex items-center justify-center">
                      <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
                        📄 Govt ID
                      </p>
                      <svg
                        className="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                    </div>
                    <input
                      id="document"
                      name="document"
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                  </label>
                </div>

                <div className="col-span-4">
                  {/* <input
                    className="border rounded-md p-2 w-full sm:col-span-2"
                    placeholder="Residential Address"
                    name="Address"
                    value={formData1.Address}
                    onChange={handleBeneficiaryDetailsInputChange}
                  /> */}
                  <FloatingLabel
                    variant="standard"
                    label="Residential Address"
                    // className=""
                    name="Address"
                    value={formData1.Address}
                    onChange={handleBeneficiaryDetailsInputChange}
                  />
                </div>

                <button
                  className="w-full bg-[#241C68] text-white py-2 rounded-md"
                  onClick={handleAddBeneficiary}
                >
                  Add
                </button>
              </div>
            </section>
            <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div>
                <h2 className="text-[#241C68] underline mb-2">
                  {" "}
                  &#x25CF; Land Acquisition Consent:
                </h2>
                <div>
                  <label>
                    <input type="radio" name="consent" />
                    <span onClick={toggleModales} className="ml-2">
                      Yes
                    </span>
                  </label>
                  <label className="ml-6">
                    <input type="radio" name="consent" />
                    <span className="ml-2">No</span>
                  </label>
                  {/* <button
                    onClick={toggleModales}
                    className="text-[#117FE5] underline ml-6"
                  >
                    View
                  </button> */}
                </div>
              </div>
              <div>
                <h2 className="text-[#241C68] underline mb-2">
                  &#x25CF; Bank Details:
                </h2>
                <button
                  onClick={toggleModal}
                  className="text-[#117FE5] underline"
                >
                  Add Bank Details
                </button>
              </div>
              <div>
                <h2 className="text-[#241C68] underline mb-2">
                  &#x25CF; Land Share Details:
                </h2>
                <button
                  onClick={toggleModals}
                  className="text-[#117FE5] underline"
                >
                  Update
                </button>
              </div>
            </section>
            <section className="mt-10">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 p-2">Beneficiary</th>
                    <th className="border border-gray-300 p-2">Contact No</th>
                    <th className="border border-gray-300 p-2">
                      Residential Address
                    </th>
                    <th className="border border-gray-300 p-2">
                      Acquisition Consent
                    </th>
                    <th className="border border-gray-300 p-2">Bank Details</th>
                    <th className="border border-gray-300 p-2">Land Share %</th>
                    <th className="border border-gray-300 p-2">
                      Compensation Amount
                    </th>
                    <th className="border border-gray-300 p-2">Govt. ID</th>
                    <th className="border border-gray-300 p-2">
                      Select for Update
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {beneficiaryDetails.map((beneficiary) => (
                    <tr key={beneficiary.BenefiaciaryId}>
                      <td className="border border-gray-300 p-2">
                        {beneficiary.Name || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {beneficiary.ContactNo || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {beneficiary.Address || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <input
                          type="checkbox"
                          disabled
                          checked={!!beneficiary.LandConsentType}
                        />
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <input
                          type="checkbox"
                          // disabled
                          className="accent-green-500"
                          checked={!!beneficiary.PaymentStatus}
                        />
                      </td>
                      <td className="border border-gray-300 p-2">
                        {beneficiary.LandShare || "25%"}
                      </td>
                      {/* <td className="border border-gray-300 p-2">{"500000"}</td> */}
                      <td className="border border-gray-300 p-2">
                        {beneficiary.CompensationAmount || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        {beneficiary.GovernmentId ? (
                          <a
                            href={getFileUrl(beneficiary.GovernmentId)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 underline"
                          >
                            View
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td className="border border-gray-300 p-2 text-center">
                        <button
                          className="text-blue-500 underline"
                          onClick={() =>
                            setSelectedBeneficiary({
                              Name: beneficiary.Name,
                              LandShare: beneficiary.LandShare,
                              CompensationAmount:
                                beneficiary.CompensationAmount,
                            })
                          }
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <button
                onClick={handleManualInsert}
                className="bg-[#241C68] items-center text-white py-2 px-10 md:px-20 mt-5 rounded-md w-full sm:w-auto"
              >
                Save
              </button> */}
            </section>
            <section className="mt-10">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 p-2">Khata No</th>
                    <th className="border border-gray-300 p-2">
                      Compensation Id
                    </th>
                    <th className="border border-gray-300 p-2">Block</th>
                    <th className="border border-gray-300 p-2">Village Name</th>
                    <th className="border border-gray-300 p-2">Village Code</th>
                    <th className="border border-gray-300 p-2">
                      Compensation Type
                    </th>
                    <th className="border border-gray-300 p-2">
                      Compensation Sub Type
                    </th>
                    <th className="border border-gray-300 p-2">View Report</th>

                    {/* <th className="border border-gray-300 p-2">Select for Update</th> */}
                  </tr>
                </thead>
                <tbody>
                  {mastermanualinsert.map((mi) => (
                    <tr key={mi.CompensationId}>
                      <td className="border border-gray-300 p-2 text-center">
                        {mi.KhataNo}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {mi.CompensationId || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {mi.Block || "N/A"}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {mi.VillageName || "N/A"}
                      </td>
                      {/* <td className="border border-gray-300 p-2 text-center">
              <input type="checkbox" disabled checked={!!mi.LandConsentType} />
            </td>
            <td className="border border-gray-300 p-2 text-center">
              <input type="checkbox" disabled checked={!!mi.PaymentStatus} />
            </td> */}
                      <td className="border border-gray-300 p-2">
                        {mi.VillageCode || "25%"}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {mi.CompensationTypeName}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {mi.CompensationSubTypeName || "N/A"}
                      </td>

                      <td className="border border-gray-300 p-2 text-center">
                        <a
                          // href={`https://reporturrda.sarmar.co.in/Report/MyReport2.aspx?CompensationId=${compensationsId}`}
                          href={`https://reporturrda.sarmar.co.in/Report/MyReport2.aspx?CompensationId=${compensationsId}`}
                          target="Blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex items-center justify-center">
                <button
                  onClick={handleManualInsert}
                  className="bg-[#241C68] text-white py-2 px-10 md:px-20 mt-5 rounded-md w-full sm:w-auto"
                >
                  Save
                </button>
              </div>
            </section>

            {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white p-6 rounded shadow-lg relative w-11/12 md:w-3/4">
                  <button
                    className="absolute top-2 right-2 text-gray-500"
                    onClick={toggleModal}
                  >
                    ✕
                  </button>
                  <AddBank
                    compensationsId={compensationsId}
                    beneficiaryNameDetails={beneficiaryNameDetails}
                    villageCodebank={villageCodebank}
                    KhataNobank={KhataNobank}
                  />
                </div>
              </div>
            )}
            {/* {isModalOpenUpdate && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-lg relative w-11/12 md:w-3/4">
            <button
              className="absolute top-2 right-2 text-gray-500"
              onClick={toggleModals}
            >
              ✕
            </button>
            <CompensationBeneficiaryUpdate />
          </div>
        </div>
      )} */}
            {isModalOpenUpdate && selectedBeneficiary && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white p-6 rounded shadow-lg relative w-11/12 md:w-3/4">
                  <button
                    className="absolute top-2 right-2 text-gray-500"
                    onClick={toggleModals}
                  >
                    ✕
                  </button>
                  <CompensationBeneficiaryUpdate
                    beneficiaryDetails={beneficiaryDetails}
                    onUpdate={handleUpdate}
                    totalCompensationAmount={totalcompensationamount}
                  />
                </div>
              </div>
            )}

            {isModalOpenLand && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white p-6 rounded shadow-lg relative w-11/12 md:w-3/4">
                  <button
                    className="absolute top-2 right-2 text-gray-500"
                    onClick={toggleModales}
                  >
                    ✕
                  </button>
                  <LandAcquistion beneficiaryDetails={beneficiaryDetails} />
                </div>
              </div>
            )}
            <div className="flex justify-end items-center">
              <button
                onClick={handleSubmit}
                className="bg-[#241C68] text-white py-2 px-10 md:px-20 mt-5 rounded-md w-full sm:w-auto"
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
      {currentStep === 2 && <SubmitProposal compensationID={compensationID} />}
    </div>
  );
};

export default ManualBeneficiary;
